import axios from "axios";
import React, { useCallback, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { supabase } from "../../config/supabase";
import { validateRecaptcha } from "../../utils/api";
import { validateNullOrEmpty } from "../../utils/Validate";


const SITE_KEY_V2 = process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY_V2 || "";
const BASE_URL =  process.env.REACT_APP_API_URL ||'';

const FormContact = () => {
  
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setCaptchaValue(value); // This will store the reCAPTCHA response
  };
  const [salaryText, setSalaryText] = useState();
  const [submitted, setSubmitted] = useState(false);
  const recaptchaRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    loan: "15tr-30tr",
    salary: "",
    phone: "",
    purpose: "Vay mua sắm",
    message: "",
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    loan: "",
    salary: "",
    phone: "",
    purpose: "",
  });
  const validateForm = useCallback(() => {
    let errors = {};
    const data = formData;
    const notRequiredMsg = "Không được để trống";
    if (!validateNullOrEmpty(data.name)) {
      errors.name = notRequiredMsg;
    }
    if (!validateNullOrEmpty(data.phone)) {
      errors.phone = notRequiredMsg;
    }
    // if (!validatePhoneNumber(data.phone)) {
    //   errors.phone = "Số điện thoại không hợp lệ";
    // }
    if (!validateNullOrEmpty(data.salary)) {
      errors.salary = notRequiredMsg;
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  }, [formData]);

  const handleChange = (e) => {
    const target = e.target;
    const { name, value } = target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // useEffect(() => {
  //   if (submitted) {
  //     validateForm();
  //   }
  // }, [formData, submitted, validateForm]);

  const handleOnBlurSalary = () => {
    const tmp = salaryText.replace(/\.|đ|Đ/g, "");
    setFormData({
      ...formData,
      salary: new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(tmp),
    });
  };

  // submit event
  const handleSubmit = async (e) => {
    e.preventDefault(); // Ngăn chặn hành vi mặc định của form (reload trang)

    // setSubmitted(true); // Đánh dấu là form đã được gửi

    // Kiểm tra tính hợp lệ của form
    if (!validateForm()) {
      toast.error("Vui lòng điền đầy đủ thông tin và xác nhận reCAPTCHA!", {
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        theme: "colored",
      });
      return;
    }

    try {
      // Nếu reCAPTCHA được xác thực
      if (captchaValue) {
        const data = {
          ...formData,
          phone: "'" + formData.phone,
        };
        await axios
          .post(BASE_URL + "/post-data", data, {
            withCredentials: true, //
          })
          .then((response) => {
            if (response.data) {
              toast.success("Đăng ký thành công!", {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                theme: "colored",
              });
            } else {
              toast.error("Vui lòng thử lại sau!", {
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                theme: "colored",
              });
            }
          });
        // Gửi dữ liệu lên Supabase
        const { data: insertedData, error: insertError } = await supabase
          .from("customers")
          .insert([data]); // Supabase yêu cầu một mảng cho multiple row insert

        if (insertError) {
          throw insertError; // Ném lỗi nếu có
        }
      }
    } catch (error) {
      toast.error("Vui lòng thử lại sau!", {
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        theme: "colored",
      });
    } finally {
      // Reset reCAPTCHA và formData sau khi gửi
      recaptchaRef.current?.reset();
      setFormData({
        name: "",
        loan: "",
        salary: "",
        phone: "",
        purpose: "",
        message: "",
      });
      setFormErrors({
        name: "",
        loan: "",
        salary: "",
        phone: "",
        purpose: "",
        message: "",
      });
      setCaptchaValue(null); // Reset lại giá trị captcha
    }
  };
  const handleRecaptchaV2Change = async (token) => {
    if (!validateForm()) return;

    try {
      const tokenV2IsValid = await validateRecaptcha({
        token: token || "",
        ver: "v2",
      });
      console.log("reCAPTCHA V2 validation:", tokenV2IsValid);

      if (tokenV2IsValid) {
        await handleSubmit();
      }
    } catch (error) {
      console.error("Error during reCAPTCHA V2 validation:", error);
    } finally {
      recaptchaRef.current?.reset();
    }
  };
  return (
    <div
      className="col-lg-6 wow fadeInUp"
      data-wow-delay="0.5s"
      id="form-contact"
    >
      <h2 className="mb-4">Nhập thông tin để được tư vấn</h2>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-sm-6">
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Họ Tên"
                value={formData.name}
                onChange={handleChange}
              />
              <label htmlFor="name">
                Họ Tên<span className="text-danger"> * </span>
              </label>
              {formErrors?.name && (
                <p className="text-danger p-0 m-0">{formErrors?.name}</p>
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                id="phone"
                name="phone"
                placeholder="Số điện thoại"
                maxLength={11}
                value={formData.phone}
                onChange={handleChange}
              />
              <label htmlFor="phone">
                Số điện thoại<span className="text-danger"> * </span>
              </label>
              {formErrors?.phone && (
                <p className="text-danger p-0 m-0">{formErrors?.phone}</p>
              )}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-floating">
              <select
                className="form-select"
                id="loan"
                name="loan"
                value={formData.loan}
                onChange={handleChange}
              >
                <option value="15tr-30tr">15tr-30tr</option>
                <option value="30tr-60tr">30tr-60tr</option>
                <option value="60tr-100tr">60tr-100tr</option>
                <option value="100tr-200tr">100tr-200tr</option>
                <option value="300tr">300tr</option>
              </select>
              <label htmlFor="loan">Chọn khoảng vay</label>
            </div>
          </div>
          <div className="col-sm-6 ">
            <div className="form-floating">
              <select
                className="form-select"
                id="service"
                name="purpose"
                value={formData.purpose}
                onChange={handleChange}
              >
                <option value="Vay mua sắm">Vay mua sắm</option>
                <option value="Vay tiêu dùng trả góp">
                  Vay tiêu dùng trả góp
                </option>
                <option value="Thẻ tín dụng">Thẻ tín dụng</option>
                <option value="khác">khác</option>
              </select>
              <label htmlFor="service">Mục đích</label>
            </div>
          </div>
          <div className="col-12">
            <div className="form-floating">
              <input
                type="text"
                className="form-control"
                id="salary"
                name="salary"
                placeholder="Mức thu nhập hằng tháng"
                value={formData.salary}
                onChange={(e) => {
                  handleChange(e);
                  setSalaryText(e.target.value);
                }}
                onBlur={handleOnBlurSalary}
                maxLength={13}
              />
              <label htmlFor="salary">
                Mức thu nhập hằng tháng
                <span className="text-danger"> * </span>
              </label>
              {formErrors?.salary && (
                <p className="text-danger p-0 m-0">{formErrors?.salary}</p>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="form-floating">
              <textarea
                className="form-control"
                placeholder="Leave a message here"
                id="message"
                style={{ height: "60px" }}
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <label htmlFor="message">Nội dung yêu cầu</label>
            </div>
          </div>
          {handleRecaptchaV2Change && (
            <ReCAPTCHA
              sitekey={SITE_KEY_V2} // Replace with your Google reCAPTCHA Site Key
              onChange={handleRecaptchaChange}
              ref={recaptchaRef}
            />
          )}
          <div className="col-12 text-center">
            <button className="btn btn-primary w-100 py-3" type="submit">
              Gửi ngay
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormContact;
